import React from 'react'
import T from 'prop-types'
import ErrorPage from 'next/error'
import { useRouter } from 'next/router'
import { groq } from 'next-sanity'

import { aboutQuery, getSettings } from '../api'
import { getClient } from '../api/sanity'
import NavList from '../components/NavList'
import SEO from '../components/SEO'
import SanityPreview from '../components/SanityPreview'
import Article from '../components/Article'
import Employees from '../components/Employees'
import useColor from '../hooks/useColor'
import { MENU } from '../constants'

const query = groq`
  *[_type == "about"][0]${aboutQuery}
`

export default function Frontpage({ preview, pageData, error, status, settings }) {
  const router = useRouter()
  useColor(null, status)

  if (!router.isFallback && !pageData) {
    return <ErrorPage statusCode={404} />
  }

  if (error) {
    return <ErrorPage statusCode={error.statusCode} title={error.title} />
  }

  return (
    <SanityPreview query={query} initialData={pageData} preview={preview}>
      {(data) => {
        return (
          <>
            <SEO title="Om oss" description={data.preamble} path="om-oss" />

            <NavList active="about" hideBack items={settings?.menu || MENU} />

            <Article title="Om oss" type="page" {...data} />

            <Employees title="Ansatte" list={data?.employees} />
          </>
        )
      }}
    </SanityPreview>
  )
}

Frontpage.propTypes = {
  pageData: T.object.isRequired,
  status: T.string,
  preview: T.bool.isRequired,
  error: T.shape({
    statusCode: T.number.isRequired,
    title: T.string.isRequired,
    purpose: T.string,
  }),
}

export async function getStaticProps({ preview = false }) {
  const pageData = await getClient(preview).fetch(query)
  const settings = await getSettings(preview)

  return {
    props: {
      preview,
      pageData,
      settings,
    },
    revalidate: 10, // Revalidate at most every 10th second
  }
}
